import api, { handleResponse, handleError } from './api';

const checkoutService = {
  /**
   * Fetch a quote for purchasing tickets to an event.
   * Works for both logged-in and anonymous users.
   *
   * @param {string} eventId
   * @param {number} quantity
   * @returns {Promise<{success: boolean, data: object|null, error: string|null}>}
   *   data: {
   *     eventId, quantity,
   *     ticketCents, prServiceFeeCents, gstCents, stripeFeeCents,
   *     balanceAvailableCents, balancePortionCents, cardPortionCents, grandTotalCents
   *   }
   */
  async getQuote(eventId, quantity = 1, promoCode = null, customPerTicketCents = null, tierId = null) {
    try {
      const params = new URLSearchParams({ quantity: String(quantity) });
      if (promoCode) params.set('promoCode', promoCode);
      if (customPerTicketCents != null) params.set('customPerTicketCents', String(customPerTicketCents));
      if (tierId) params.set('tierId', String(tierId));
      const response = await api.get(`/events/${eventId}/checkout/quote?${params.toString()}`);
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  /**
   * Confirm checkout for an existing application — triggers balance-first charge with
   * optional Stripe card charge for any remainder.
   *
   * @param {string} eventId
   * @param {string} applicationId
   * @param {string|null} stripeCustomerId  — required if card portion > 0
   * @param {string|null} stripePaymentMethodId — required if card portion > 0
   * @returns {Promise<{success: boolean, data: object|null, error: string|null}>}
   */
  async confirmCheckout(eventId, applicationId, stripeCustomerId = null, stripePaymentMethodId = null, promoCode = null, skipBalance = false) {
    try {
      const response = await api.post(`/events/${eventId}/checkout/confirm`, {
        applicationId,
        stripeCustomerId,
        stripePaymentMethodId,
        promoCode,
        skipBalance,
      });
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },
};

export default checkoutService;
